import { render, staticRenderFns } from "./WebchatDetail.vue?vue&type=template&id=88390846&scoped=true&"
import script from "./WebchatDetail.vue?vue&type=script&lang=js&"
export * from "./WebchatDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebchatDetail.vue?vue&type=style&index=0&id=88390846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88390846",
  null
  
)

export default component.exports